import { useState } from 'react';
import { FileTreeFile } from './file-tree-file';

export const FileTreeSub = ({ folder, parent, setPath, getImage }) => {

    const pathData = { path: folder.name, contents: folder.contents, parent: parent };
    const [expanded, setExpanded] = useState(false);


    return folder && folder.contents && (

        <div style={{ cursor: 'pointer' }} className={`file-node has-sub ${expanded ? "expand selected" : ""}`} onClick={e => { e.stopPropagation(); setExpanded(!expanded); setPath(pathData) }}>
            <a href="#/" className="file-link">
                <span className="file-arrow"></span>
                <span className="file-info" >
                    <span className="file-icon"><i className={`fa ${getImage('folder').icon} fa-lg text-warning`}></i></span>
                    <span className="file-text">{folder.name}</span>
                </span>
            </a>
            <div className="file-tree">
                {folder.contents && folder.contents.map((item, i) => {
                    return item.isFolder ?
                        <FileTreeSub key={`${item.name}-sub-${i}`} getImage={getImage} folder={item} parent={folder} setPath={setPath} />
                        :
                        <FileTreeFile key={`${item.name}-file-${i}`} getImage={getImage} file={item} parent={folder} setPath={setPath} />
                }
                )}
            </div>
        </div>
    );
};